export const REQUEST_HEADSETS = 'REQUEST_HEADSETS';
export const RECEIVE_HEADSETS = 'RECEIVE_HEADSETS';
export const INVALIDE_HEADSETS = 'INVALIDE_HEADSETS';
export const FORMAT_HEADSETS = 'FORMAT_HEADSETS';

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
